import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { api, API } from "@/lib/api";
import { useAuth } from "@/lib/auth";

const BrandCtx = createContext({ tenant: null, refresh: () => {} });
export const useBrand = () => useContext(BrandCtx);
export const logoSrc = (t) => (t?.logo_url ? `${API}/tenants/${t.slug}/logo?v=${encodeURIComponent(t.logo_url.slice(-12))}` : null);

function hexToRgb(hex) { const h = hex.replace("#", ""); const f = h.length === 3 ? h.split("").map(c => c + c).join("") : h; const n = parseInt(f, 16); return [(n >> 16) & 255, (n >> 8) & 255, n & 255]; }
const shade = (hex, k) => { const [r, g, b] = hexToRgb(hex); const m = v => Math.max(0, Math.min(255, Math.round(v * k))); return `rgb(${m(r)}, ${m(g)}, ${m(b)})`; };

export function applyBrand(color) {
  const root = document.documentElement;
  if (!color) { root.classList.remove("brand-theme"); root.style.removeProperty("--brand"); root.style.removeProperty("--brand-dark"); root.style.removeProperty("--brand-soft"); return; }
  const [r, g, b] = hexToRgb(color);
  root.style.setProperty("--brand", color); root.style.setProperty("--brand-dark", shade(color, 0.85)); root.style.setProperty("--brand-soft", `rgba(${r}, ${g}, ${b}, 0.12)`);
  root.classList.add("brand-theme");
}

export function BrandProvider({ children }) {
  const { user } = useAuth();
  const [tenant, setTenant] = useState(null);
  const refresh = () => api.get("/tenants/me").then(r => setTenant(r.data)).catch(() => setTenant(null));
  useEffect(() => { if (user) refresh(); else { setTenant(null); applyBrand(null); } }, [user?.id, user?.tenant_id]); // eslint-disable-line
  useEffect(() => { applyBrand(tenant?.primary_color || null); }, [tenant?.primary_color]);
  const v = useMemo(() => ({ tenant, refresh, setTenant }), [tenant]);
  return <BrandCtx.Provider value={v}>{children}</BrandCtx.Provider>;
}
